import { Col, Divider, Form, message, Row } from "antd";
import React, { useEffect } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useStaffContractsStore } from "../../../../config/stores";
import AntdModal from "../../../common/AntdModal";
import AppButton from "../../../common/AppButton";
import AppInput from "../../../common/AppInput";

const WorkAreasForm = () => {
  const staffContractStore = useStaffContractsStore();
  const {
    workAreaToUpdate,
    creatingWorkArea,
    showCreateWorkArea,
    updatingWorkArea,
    addingWorkArea,
    staffContractDetails,
  } = staffContractStore;
  const [form] = Form.useForm();

  const closeModal = () => {
    staffContractStore.setCreatingWorkArea();
  };

  const onSubmit = () => {
    form
      .validateFields()
      .then((data) => {
        data.staff_contract_id = staffContractDetails.id;
        if (staffContractStore.creatingWorkArea) {
          staffContractStore.createWorkArea(data);
        } else {
          staffContractStore.updateWorkarea(workAreaToUpdate.id, data);
        }
      })
      .catch((err) => {
        message.error("Please fill in the form correctly");
      });
  };

  useEffect(() => {
    if (creatingWorkArea) {
      form.resetFields();
    } else {
      form.setFieldsValue({
        ...workAreaToUpdate,
      });
    }
  }, [creatingWorkArea, workAreaToUpdate, form]);
  return (
    <AntdModal
      title={creatingWorkArea ? "ADD WORK AREAS" : "EDIT WORK AREAS"}
      open={showCreateWorkArea}
      closeModal={closeModal}
      customSize={1000}
      footer={[
        <AppButton
          text={creatingWorkArea ? "SAVE" : "SAVE UPDATES"}
          key={"create"}
          loading={addingWorkArea || updatingWorkArea}
          onClick={onSubmit}
        />,
        <AppButton text="CANCEL" key={"cancel"} onClick={closeModal} danger />,
      ]}
    >
      <Form layout="vertical" form={form}>
        <AppInput
          label="Work Area"
          name="work_area"
          rules={[
            {
              required: true,
              message: "Work area is required",
            },
          ]}
        />
        {creatingWorkArea && (
          <>
            <Divider className="fw-bold text-uppercase">
              Roles And Responsibilities
            </Divider>
            <Form.List
              name="responsibilities"
              rules={[
                {
                  validator: async (_, names) => {
                    if (!names || names.length < 1) {
                      return Promise.reject(
                        new Error("At least 1 indicator is required")
                      );
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map((field, index) => (
                    <Row gutter={4} key={field.key}>
                      <Col span={22}>
                        <AppInput
                          label="Role/Responsibility"
                          name={[field.name, "responsibility"]}
                          rules={[
                            {
                              required: true,
                              whitespace: false,
                              message: "This field is required",
                            },
                          ]}
                        />
                      </Col>
                      <Col span={1}>
                        <Form.Item label=" ">
                          {fields.length > 1 ? (
                            <span className="text-danger mx-1">
                              <MinusCircleOutlined
                                className="dynamic-delete-button"
                                onClick={() => remove(field.name)}
                              />
                            </span>
                          ) : null}
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <AppButton
                      type="dashed"
                      text="Add"
                      block
                      onClick={() => add()}
                      iconBefore={<PlusOutlined />}
                    />

                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>
          </>
        )}
      </Form>
    </AntdModal>
  );
};

export default WorkAreasForm;
